export default __webpack_public_path__ + "static/media/logo.61d31e3c.png";